import { generatePath } from "@routes/utils";

import type { IExtractParams } from "@routes";

const pathBase = `/files/`;
const pathById = `${pathBase}:fileId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const files = {
  getAll: (param: IPathBaseParam) => generatePath(pathBase, param),
  post: (param: IPathBaseParam) => generatePath(pathBase, param),
  put: (param: IPathByIdParam) => generatePath(pathById, param),
  delete: (param: IPathByIdParam) => generatePath(pathById, param),
} as const;
